export default __webpack_public_path__ + "static/media/americanas.75e5c459.svg";